import { useTranslation } from 'react-i18next';
import { css } from '@emotion/react';
import { Icon } from '@anytag/shared-atoms';
import { THEME } from '@anytag/shared-constants';
import { Notice, NoticeProps } from './notice';

export interface ErrorsProps {
  className?: string;
  message?: NoticeProps['message'];
  onRegenerateResponse?: () => void;
  type?: 'network-error' | 'over-requests' | 'generate-failed';
}

export const Errors = ({ type, message, className, onRegenerateResponse }: ErrorsProps) => {
  const { t } = useTranslation();

  const renderError = () => {
    switch (type) {
      case 'over-requests':
        return <Notice type="error" message={t('Error.Too many request')} />;
      case 'network-error':
        return (
          <>
            <Notice type="error" message={t('Error.AI stopped generating')} />

            <div css={[styles.buttonWrapper(), { backgroundColor: '#FFCFCF' }]}>
              <div css={styles.iconWrapper}>
                <Icon icon="wifi-off" size={12} variant="red" />
              </div>
              <p css={{ color: THEME.text.colors.red.lv1 }}>{t('Network Error')}</p>
            </div>
          </>
        );
      case 'generate-failed':
        return (
          <>
            <Notice type="error" message={t('Error.Generating failed')} />

            <div
              onClick={onRegenerateResponse}
              css={[styles.buttonWrapper(!!onRegenerateResponse), { backgroundColor: '#EEF3F7' }]}
            >
              <div css={styles.iconWrapper}>
                <Icon icon="refresh" size={12} variant="gray" />
              </div>
              <p>{t('Regenerate response')}</p>
            </div>
          </>
        );
      default:
        return message ? <Notice type="error" message={message} /> : null;
    }
  };

  return (
    <div css={{ padding: '24px 16px' }} className={className}>
      {renderError()}
    </div>
  );
};

const styles = {
  buttonWrapper: (canClick?: boolean) =>
    css({
      gap: '4px',
      height: '40px',
      display: 'flex',
      fontSize: '12px',
      fontWeight: 400,
      padding: '0 16px',
      lineHeight: '120%',
      fontStyle: 'normal',
      width: 'max-content',
      borderRadius: '28px',
      alignItems: 'center',
      margin: '24px auto 0',
      boxSizing: 'border-box',
      cursor: canClick ? 'pointer' : 'default'
    }),
  iconWrapper: css({
    flex: 'none',
    width: '24px',
    height: '24px',
    display: 'flex',
    borderRadius: '50%',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: THEME.background.colors.white
  })
};
